import { dedupe, getRandomArrayElement } from "../shared/util";

// target is a random grapheme from word
// graphemes is all graphemes from word
export function getDistractors(target, graphs) {
  // if digraph...
  if (isDigraph(target)) {
    return [
      ...getRandomGraphemes(graphs, "vowel", target, 1),
      ...getRandomGraphemes(graphs, "consonant", target, 1),
      ...getRandomGraphemes(graphs, "digraph", target, 1),
    ];
  }

  // if consonant or vowel...
  return [
    ...getRandomGraphemes(graphs, "vowel", target, 1),
    ...getRandomGraphemes(graphs, "consonant", target, 2),
  ];
}

function isVowel(g) {
  if (isDigraph(g)) return false;
  return graphemes.vowel.includes(g);
}

function isConsonant(g) {
  if (isDigraph(g)) return false;
  return !isVowel(g);
}

function isDigraph(g) {
  return g.length === 2;
}

// graphemes: graphemic breakdown array
// type: enum vowel, consonant, digraph
// target: target grapheme
// count: how many random graphemes to retrieve
function getRandomGraphemes(graphs, type, target, count = 0) {
  const filter = {
    vowel: isVowel,
    consonant: isConsonant,
    digraph: isDigraph,
  }[type];

  const options = dedupe(graphs.filter(filter).filter((g) => g !== target));

  const pool = graphemes[type];

  while (options.length < count) {
    const g = getRandomArrayElement(pool);
    if (options.includes(g)) continue;
    if (g === target) continue;
    options.push(g);
  }

  return options.slice(0, count);
}

const graphemes = {
  vowel: ["a", "e", "i", "o", "u"],
  consonant: [
    "b",
    "c",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "m",
    "n",
    "p",
    "r",
    "s",
    "t",
    "v",
    "w",
    "x",
    "z",
  ],
  digraph: [
    "ae",
    "ai",
    "ar",
    "au",
    "aw",
    "ay",
    "bb",
    "ce",
    "ch",
    "ck",
    "dd",
    "di",
    "ea",
    "ed",
    "ee",
    "ei",
    "eo",
    "er",
    "ew",
    "ey",
    "ff",
    "ft",
    "ge",
    "gg",
    "gh",
    "gn",
    "gu",
    "ho",
    "ir",
    "kn",
    "ll",
    "mm",
    "mb",
    "mn",
    "lm",
    "ng",
    "nn",
    "oa",
    "oe",
    "oi",
    "oo",
    "or",
    "ou",
    "ow",
    "oy",
    "ph",
    "pn",
    "pp",
    "ps",
    "qu",
    "rh",
    "rr",
    "sc",
    "se",
    "si",
    "ss",
    "st",
    "th",
    "ti",
    "tt",
    "tu",
    "ue",
    "ui",
    "ur",
    "ve",
    "wh",
    "wr",
    "yr",
    "ze",
    "zz",
  ],
};
